import { Theme } from '@mui/material';

export const Styles = (theme: Theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      fontSize: theme.typography.textSize['0_875'],
      fontWeight: theme.typography.fontWeight.small,
      lineHeight: theme.typography.lineHeight.xSmall,
      color: theme.palette.text.septenary,
      marginBottom: theme.custom.margin.xSmall,
    },
    formContainer: {
      display: 'flex',
      width: theme.custom.width['100%'],
      marginBottom: theme.custom.margin.xSmall,
      '@media (max-width: 576px)': {
        marginBottom: theme.custom.margin.small,
      },
    },
    flagCodeContainer: {
      minWidth: 'min(8.4rem, 100%)',
      backgroundColor: theme.palette.background.black_1200,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      color: 'white',
      gap: theme.custom.gap.xSmall,
      padding: theme.custom.padding.medium,
      border: `0.063rem solid ${theme.custom.customColors?.['GREY_800']}`,
      height: theme.custom.height['3_5'],
      borderRadius: `${theme.custom.borderRadius.medium} 0 0 ${theme.custom.borderRadius.medium}`,
      position: 'relative',
      cursor: 'pointer',
      '@media (max-width: 1300px)': {
        padding: `${theme.custom.padding.medium} ${theme.custom.padding.small}`,
      },
      '@media (max-width: 576px)': {
        justifyContent: 'space-around',
        gap: 0,
      },
    },
    flagCode: {
      display: 'flex',
      gap: theme.custom.gap.xSmall,
      alignItems: 'center',
    },
    flag: {
      width: theme.custom.width['1_5'],
      height: theme.custom.height['1'],
    },
    countryDropdown: {
      top: '105%',
      left: '0',
      maxHeight: theme.custom.height['15'],
      outline: 'none',
      borderRadius: theme.custom.borderRadius.medium,
      '&::WebkitScrollbar': {
        display: 'none',
      },
    },
    inputStyle: {
      flex: '1',
      width: theme.custom.width['100%'],
      backgroundColor: theme.palette.background.black_1200,
      padding: `0 ${theme.custom.padding.medium}`,
      height: theme.custom.width['3_5'],
      border: `0.063rem solid ${theme.palette.secondary.quaternary}`,
      borderRadius: `0 ${theme.custom.borderRadius.medium} ${theme.custom.borderRadius.medium} 0`,
      color: theme.palette.text.elevenary,
      fontSize: theme.typography.textSize.medium,
      outline: 'none',
      boxShadow: 'none',
      '@media (maxWidth: 576px)': {
        fontSize: theme.typography.textSize['0_875'],
      },
    },
    error: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.custom.gap.xSmall,
      color: theme.palette.quinary?.red_400,
      fontSize: theme.typography.textSize.small,
      fontWeight: theme.typography.fontWeight.medium,
      lineHeight: theme.typography.lineHeight['1_125'],
    },
  };
};
